import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

EraseDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    busy: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

/**
 * The last step of a right of erasure: what goes, what stays, and that it cannot be undone.
 */
function EraseDialog({open, busy, onConfirm, onClose}) {
    return (
        <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle><FormattedMessage id="personalShopper.privacy.erase.title" /></DialogTitle>
            <DialogContent>
                <DialogContentText><FormattedMessage id="personalShopper.privacy.erase.help" /></DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={busy} sx={{textTransform: "none"}}>
                    <FormattedMessage id="personalShopper.privacy.erase.cancel" />
                </Button>
                <Button variant="contained" color="error" disabled={busy} onClick={onConfirm} sx={{textTransform: "none"}}>
                    <FormattedMessage id="personalShopper.privacy.erase.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EraseDialog;
